<section class="page_devicedetail">
  <div class="board">
    <CardInfo @setCalibration="setCalibration" :dataInfo="state.rawData" :btn2="t('__d4e_m8t.__unbind')" :btn1="t('__d4e_m8t.__setCalibration')" @setUnbind="setUnbind" class="cardInfo">
      <template #card="{ data}">
        <div class="contentgroup">
          <div class="contentgroup_top">
            <div class="contentgroup_title">
              <div class="titleType">{{t('__common.__model')}}</div>
              <div class="title">{{state.rawData.model}}</div>
            </div>
          </div>
          <div class="border">
            <ul ref="deviceDetailPage">
              <li v-for=" (e,i) in state.modelCol" class="li" @mouseenter="showGroupName($event,e)"
                @mouseleave="handleFocusOut">
                <!-- @click.stop="showGroupName($event,e)" v-click-outside="handleFocusOut" -->
                <span >{{t(e.title)}} : {{e.val == 'status'? modelStatus[state.rawData[e.val]]: state.rawData[e.val]}}</span>
              </li>
              <div v-for="(e,i) in state.modelCol" :style="itemClass" class="tooltips"
                :class="[e.show && state.detail && state.detail == state.rawData[e.val] ? 'show':'noshow']">
                <div>{{state.detail}}{{e.aa}}</div>
              </div>
            </ul>
          </div>

        </div>
      </template>
    </CardInfo>

    <Tab class="tab" :tabText="tabText" :defaultActiveIndex="$route.params.tabId" @onClick="onClickTab"></Tab>



    <div class="tabContent" v-if="$route.params.tabId == tabText[0].val">
      <div>
        <div class="tabHeader">
          <div class="select-block">
            <Select @onChange="selectChange" :options="state.etOption" v-model:selected="state.selectVal1"
             ></Select>
          </div>
          <div class="right">
            <iCon class="icon" @mouseenter="dataLimitInfo()" @mouseleave="handleLimitOut" iconClass="top-info_n"
            @keypress.enter="state.showLimitInfo  = !state.showLimitInfo " :tabindex=" 0"></iCon>
            <!-- @click.stop="dataLimitInfo()" -->
            <div :class="[state.showLimitInfo ? 'show':'noshow']" class="tooltips trangle">
              <!-- v-click-outside="handleLimitOut" -->
              <div>{{t('__d4e_m8t.__theNumberOfExecutedTasksIsUpTo50')}}</div>
            </div>
            <div class="count">{{state.rawData.task_executed_count}}/50</div>
            <Button type="full" @onClick="deleteET" :disable="!state.list.length" class="btn-inline" colors="dark1"
              theme="2" wd="sm" icon="asus_proart_sw_ico_delete" :text="t('__g3p_m8t.__delete')"></Button>
          </div>
        </div>
        <div class="tabMainBlock">
          <Table @tableSort="tableSort" :disableCheck="state.tableETDisableList" @onCheckAll="onCheckAll"
            @showCTAndRow="showCTAndRow" @onCheckEach="onCheckEach" @goTableLink="goTableLink"
            :columns="exeListCol" :defaultCheck="state.defaultCheckIndexList" :data="state.exeListData"
            tablePadding="20" :checkBox="true">
            <template #custom="{data, row,index,title,text}">
              <div v-if="data.depiction_code || data.depiction_code == 0">{{t(title[text])}} [{{data.depiction_code}}]  {{transferDepictionCode(ERRORDESC,data.depiction_code)}}</div>
              <div v-if="data.depiction_code == null">{{t(title[text])}} [code] {{t('__main.__error')}}</div>
            </template>
            <template #second="{index, data}">
              <TableInfo :data="data.dataInfo" :columns="appList2col">
                <!-- <template #button="{data}">  :custom="'button'"
                  <Button class="btn-inline" type="border" @onClick="applyCalibration(data)" text="Apply to Calibration"></Button> 
                </template> -->
              </TableInfo>
            </template>
            <template #reportth="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #report="{index, data, text}">
              <span class="editIcon" @click="report(data)"
              @keypress.enter="report(data)" :tabindex=" !text ? -1 : 0">
                <iCon iconClass="asus_proart_sw_ico_file_text" :class="{'noEdit': !text}"></iCon>
              </span>
            </template>


            <template #modeColDatath="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #modeColData="{index, data, text, col}">
              <span >
                {{modeCol(data, col)}}
              </span>
            </template>

            


            <!-- <template #contextMenu="{position}">
              <CTmenu @selectContextMenu="selectContextMenu" :position="position"></CTmenu>
            </template> -->
            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__noAnyTask')}}</div>
            </template>
          </Table>

        </div>
      </div>

      <div class="tabFooter">
        <Pagination :totalPage="state.meta.total_page" :input="true" position="start" :nowPage="state.meta.current"
          :range="5" @changePage="changePage"></Pagination>
      </div>
    </div>



    <div class="tabContent" v-if="$route.params.tabId == tabText[1].val">
      <div>
        <div class="tabHeader">
          <div class="select-block">
            <Select :options="state.apOption" v-model:selected="state.selectVal1"></Select>
          </div>
          <div class="right">

            <iCon class="icon" @mouseenter="dataLimitInfo()" @mouseleave="handleLimitOut" iconClass="top-info_n"
            @keypress.enter="state.showLimitInfo  = !state.showLimitInfo " :tabindex=" 0"></iCon>
            <div :class="[state.showLimitInfo ? 'show':'noshow']" class="tooltips trangle">
              <div>{{t('__d4e_m8t.__theMaximumNumberOfAppointmentIs80')}}</div>
            </div>
            <div class="count">{{state.rawData.appointment_count}}/80</div>
            <Button type="full" class="btn-inline" :disable="!state.list.length" @onClick="deleteAP" colors="dark1"
              theme="2" wd="sm" icon="asus_proart_sw_ico_delete" :text="t('__g3p_m8t.__delete')"></Button>
          </div>
        </div>
        <div class="tabMainBlock">
          <Table @tableSort="tableSort" :disableCheck="state.tableAPDisableList" @onCheckAll="onCheckAll"
            @showCTAndRow="showCTAndRow" @onCheckEach="onCheckEach" @goTableLink="goTableLink" :dropdown="'dataInfo'"
            :columns="appListCol" :data="state.appListData" tablePadding="20" :checkBox="true"
            :defaultCheck="state.defaultCheckIndexList">
            <template #second="{index, data}">
              <div class="dataInfo">
                
                <div v-for="(each , i) in data.dataInfo">
                  <TableInfo :columns="setAppListColSub(each.col)" :data="each.data">
                  </TableInfo>
                </div>
              </div>
            </template>

            <template #repeatColDatath="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #repeatColData="{index, data, text, col}">
              <span >
                {{setRepeatCol(data)}}
              </span>
            </template>


            <template #modifyth="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #modify="{index, data, text}">
              <span class="editIcon" @click="editApp(data)"
              @keypress.enter="editApp(data)" :tabindex=" 0">
                <iCon iconClass="asus_proart_sw_ico_edit_1"></iCon>
              </span>
            </template>
            <!-- <template #contextMenu="{position}">
              <CTmenu @selectContextMenu="selectContextMenu" :position="position"></CTmenu>
            </template> -->
            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__noAnyAppointment')}}</div>
            </template>
          </Table>

        </div>
      </div>

      <div class="tabFooter">
        <Pagination :totalPage="state.meta.total_page" :input="true" position="start" :nowPage="state.meta.current"
          :range="5" @changePage="changePage"></Pagination>
      </div>
    </div>

    <div class="tabContent" v-if="$route.params.tabId == tabText[2].val">
      <div class="setting">
        <div class="title">{{t('__d4e_m8t.__permissionSettings')}}</div>
        <div class="warn">{{t('__d4e_m8t.__allowsFunctionsThatCanBeUsed')}}</div>
        <div class="setblock">
          <div class="set ">
            <div class="option" v-for="e in state.settingIcon">
              <Switcher v-model:isCheck="e.status" class="switcher"></Switcher>
              <!-- <iCon @click="settingLock(e)" :class="{'gold': e.status }"
                :iconClass="e.status ? 'asus_proart_sw_ico_lock' : 'asus_proart_sw_ico_unlock'" class="settingIcon">
              </iCon> -->
              <span>{{t(e.text)}}</span>
            </div>
          </div>
          <Button id="GTM__permissionSettingsApplyDevice" @onClick="editDeviceSetting" :text="t('__common.__apply')" class="btn-inline" type="full"
            colors="main2-gradient"></Button>
        </div>
        <div class="divide"></div>
        <div class="title">{{t('__d4e_m8t.__osdSettings')}}</div>
        <div class="warn">
          <div>
            {{t('__d4e_m8t.__toRemotelySetOsdSettingsAlert')}}
          </div>
          <Button id="GTM__resetToDefault" @onClick="reset" :disable="state.waitForProfile || !state.deviceCheck.length" :text="t('__d4e_m8t.__resetToDefault')" class="btn-inline"
            type="border"></Button>
        </div>
        <div class="status">{{t('__d4e_m8t.__thunderboltUsbConnectionStatus')}} : {{state.rawData.usb_connected ? t('__d7d_n17r.__connected') : t('__d4e_m8t.__disconnect') }}</div>

        <div class="formContentBlock">
          <div v-for="(each, i) in state.profileList">
            <div class="formTitle">{{each.modeName}}</div>
            <Select :options="each.option" v-model:selected="each.current" @onChange="currentChange"
              :isDisable="each.disable || state.waitForProfile"></Select>
          </div>


        </div>



        <div class="applyBtn">
          <Button id="GTM__osdSettingsApply" @onClick="applyProfile" :disable="state.waitForProfile || state.noChange" :text="t('__common.__apply')" class="btn-inline" type="full"
            colors="main2-gradient"></Button>
        </div>
        <div class="applyBtn">
          <div v-if="state.rawData['osd_apply']">{{t('__d4e_m8t.__osdProfileIsApplyingNow')}}</div>
        </div>
        <!-- <div class="applyBtn">
          <div>state.waitForProfile : {{state.waitForProfile}}</div>
          <div>wsData : {{$store.state.wsData}}</div>
          <Button  @onClick="testWs"   text="testWs" class="btn-inline" type="full" colors="main2-gradient" ></Button>
          <Button  @onClick="changeWSResult"   text="changeWSResult" class="btn-inline" type="full" colors="main2-gradient" ></Button>
        </div> -->
      </div>
    </div>




  </div>

</section>